import { Box, SxProps, Theme } from '@mui/material'
import React from 'react'

interface NewBadgeProps {
    /** Localized badge text, e.g. "NEW" / "جديد". */
    label: string
    /** Optional style overrides (e.g. absolute positioning above a tab). */
    sx?: SxProps<Theme>
}

/** Small green pill used to flag a new feature (e.g. Multi-city). */
const NewBadge: React.FC<NewBadgeProps> = ({ label, sx }) => (
    <Box
        component="span"
        sx={{
            display: 'inline-flex',
            alignItems: 'center',
            bgcolor: 'success.main',
            color: 'common.white',
            fontSize: '0.625rem',
            fontWeight: 700,
            lineHeight: 1,
            py: '2px',
            px: '6px',
            borderRadius: '4px',
            textTransform: 'uppercase',
            whiteSpace: 'nowrap',
            ...sx
        }}
    >
        {label}
    </Box>
)

export default NewBadge
